var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssetCondition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55304 4.15698C8.81727 4.02618 8.87233 3.67318 8.66048 3.46813L7.63177 2.47241L5.63283 4.42521V3.33424H3.48548V6.52537L2.1875 7.79343L2.78679 8.40393L3.48548 7.71977V12.0974H11.9285L11.9243 8.10485C11.924 7.86922 11.733 7.67835 11.4973 7.67835C11.2613 7.67835 11.0701 7.86982 11.0704 8.10582L11.0743 11.2435H9.07758V8.5968H6.18671V11.2435H4.33944V6.88503L7.63688 3.66437L8.06694 4.08104C8.19659 4.20666 8.39126 4.23707 8.55304 4.15698ZM4.33944 5.69045V4.18822H4.77893V5.25965L4.33944 5.69045ZM7.04067 11.2435V9.45079H8.22362V11.2435H7.04067Z",
    fill: "#0E504C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 3.9375C9.80508 3.9375 9.59637 4.1462 9.59637 4.40365V5.09219C9.59637 5.34964 9.80508 5.55835 10.0625 5.55835C10.32 5.55835 10.5287 5.34964 10.5287 5.09219V4.40365C10.5287 4.1462 10.32 3.9375 10.0625 3.9375Z",
    fill: "#0E504C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34115 5.65884C8.0837 5.65884 7.875 5.86755 7.875 6.125C7.875 6.38245 8.0837 6.59115 8.34115 6.59115H9.02969C9.28714 6.59115 9.49585 6.38245 9.49585 6.125C9.49585 5.86755 9.28714 5.65884 9.02969 5.65884H8.34115Z",
    fill: "#0E504C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0953 5.65884C10.8379 5.65884 10.6292 5.86755 10.6292 6.125C10.6292 6.38245 10.8379 6.59115 11.0953 6.59115H11.7839C12.0413 6.59115 12.25 6.38245 12.25 6.125C12.25 5.86755 12.0413 5.65884 11.7839 5.65884H11.0953Z",
    fill: "#0E504C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 6.69165C9.80508 6.69165 9.59637 6.90036 9.59637 7.15781V7.84635C9.59637 8.1038 9.80508 8.3125 10.0625 8.3125C10.32 8.3125 10.5287 8.1038 10.5287 7.84635V7.15781C10.5287 6.90036 10.32 6.69165 10.0625 6.69165Z",
    fill: "#0E504C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetCondition);
export default __webpack_public_path__ + "static/media/assetCondition.25fcde1f366621bd0558ecf0ebddc9ab.svg";
export { ForwardRef as ReactComponent };